import courage from "../../assets/courage.png";
import compassion from "../../assets/compassion.png";
import curiosity from "../../assets/curiosity.png";

const features = [
  {
    name: "Courage",
    description:
      "The ability to find strength, withstand fear & act with integrity regardless of the circumstance.",
    href: "#",
    icon: courage,
  },
  {
    name: "Compassion",
    description:
      "Empowering people to bring about fairness, inclusiveness & joy though purposeful actions & kindness.",
    href: "#",
    icon: compassion,
  },
  {
    name: "Curiosity",
    description:
      "Strong desire to evolve, learn, & challenge. A mindset of creating endless possibilities.",
    href: "#",
    icon: curiosity,
  },
];

export default function Example() {
  return (
    <div className="">
      <h2 className="text-left font-semibold leading-7 text-gold mb-10">
        Our Values
      </h2>
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-2xl lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-10 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col p-4 rounded-md">
                <dt className="text-2xl text-left font-semibold text-gray-900">
                  <div className="mb-6 flex items-center justify-left rounded-l">
                    <img
                      alt={feature.name}
                      src={feature.icon}
                      className="h-14 w-auto bg-gold rounded-md"
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-1 flex flex-auto text-left flex-col text-lg text-gray-900">
                  <p className="flex-auto">{feature.description}</p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
